module.exports = __webpack_public_path__ + "static/media/LoginBackground.c27bb7b4.svg";